module.exports = __webpack_public_path__ + "static/media/modifier-cercle.32160812.png";